<template>
    <div class="slider-default section">
        <div class="container">
            <div class="slider-default__static section-margin">
                <h1 class="title slider-default__static-title">
                    Ролатекс — создаём комфорт!
                </h1>
                <p class="slider-default__static-text">
                    Производство и монтаж систем затемнения и моторизированных
                    систем для дома и улицы
                </p>
                <a class="link _underline _center" href="/o-nas">
                    <span>О компании</span>
                    <svg viewBox="0 0 13 20">
                        <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
                    </svg>
                </a>
            </div>
            <div class="section-promo">
                <VueSlickCarousel class="slider-default__promo-slider slider" v-if="sliderItems" ref="promo" v-bind="slickOptionsText" @beforeChange="syncSliders">
                    <div v-for="(sliderItem, i) of sliderItems" :key="i">
                        <a class="section-promo__ex-title" :href="sliderItem.link_url">
                            {{ sliderItem.message }}
                        </a>
                        <p class="slider-default__count">
                            <span class="_active">{{ ++i }}</span>/{{ sliderItems.length }}
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>
            <VueSlickCarousel class="slider-default__img-slider slider" v-if="sliderItems" ref="img" v-bind="slickOptionsImg" @beforeChange="syncSliders">
                <a class="slider-default__img-slider-wrapper" v-for="(sliderItem, i) of sliderItems" :key="i" :href="sliderItem.link_url">
                    <img class="slider-default__img-slider-img" :src="sliderItem.imgSrc" :alt="sliderItem.message + ' фото'" />
                </a>
                <template #prevArrow="arrowOption">
                    <button type="button" class="slick-arrow _prev">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
                <template #nextArrow="arrowOption">
                    <button type="button" class="slick-arrow _next">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";

    export default {
        name: "mainSlider",
        components: { VueSlickCarousel },
        data() {
            return {
                slickOptionsText: {
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 12000,
                    infinite: true,
                    asNavFor: this.$refs.img,
                },
                slickOptionsImg: {
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                    infinite: true,
                    lazyLoad: "ondemand",
                    asNavFor: this.$refs.promo,
                },
                sliderItems: null,
            };
        },
        methods: {
            syncSliders(currentPosition, nextPosition) {
                this.$refs.img.goTo(nextPosition);
                this.$refs.promo.goTo(nextPosition);
            },
        },
        created() {
            this.$http.get("/api/slider/main").then((res) => {
                this.sliderItems = res.data;
            });
        },
    };
</script>
